import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import PositionActions from '../actions/PositionActions';


const PositionSource = {
    getPositions() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.positionList).fetch();
            },

            local(state) {
                // So we don't do the call again when rendering clientside
                return state.positions.length ? state : null;
            },

            success: PositionActions.getSuccess,
            error: CurrentUserActions.pageFault
        };
    }
};

class PositionStore {
    constructor() {
        this.positions = [];

        this.exportAsync(PositionSource);
        this.bindActions(PositionActions);
    }

    onGetSuccess(positions) {
        this.setState({positions})
    }
}

export default createStore(PositionStore, 'PositionStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/PositionStore.js
 **/